export default __webpack_public_path__ + "static/media/reports_icon.6032d378.svg";